import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { OrgService } from '../_services/org.service';
import { PhaseService } from '../_services/phase.service';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
})
export class DashboardTeacherComponent implements OnInit {
	subscriptions: Subscription[] = [];
	selectedSchool: any;
	phases: any;
	selectedClassroom: any;

	constructor(private orgService: OrgService, private router: Router, public phaseService: PhaseService) {}

	ngOnInit(): void {
		this.orgService.init();
		this.subscriptions.push(
			this.orgService.selectedSchool$.subscribe((data: any) => {
				this.selectedSchool = data;
			})
		);

		this.subscriptions.push(
			this.orgService.selectedClassroom$.subscribe((data: any) => {
				this.selectedClassroom = data;
			})
		);
	}

	goToMainDash() {
		this.router.navigateByUrl('/dashboard');
	}
	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
